import aes from "crypto-js/aes";
import enc from "crypto-js/enc-utf8";
import md5 from "crypto-js/md5";
import { DEFAULT_LOCALE, LOCALE_OPTIONS } from "@/constants/config";
import { logException } from "./logger";

const KEY = "bNb0k@bEG8yZuwKKc$@K#t2KN$ywGs1K";
const IV = "QCvDjMkcQMGXYxwD";

export const getCurrentLanguage = (): string => {
  let locale = DEFAULT_LOCALE;
  try {
    const current = localStorage.getItem("currentLanguage");
    if (current && LOCALE_OPTIONS.filter((x) => x.id === current).length > 0) {
      locale = current;
    }
  } catch (error) {
    logException(error);
    // console.log("[RHINO] >>> src/utils/index.js : getCurrentLanguage -> error", error);
    locale = DEFAULT_LOCALE;
  }
  return locale;
};

export const getBase64DataURL = (file: File): Promise<string> => {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });
};

export const getBase64FromDataURL = (result: string): string => {
  // extracts the base64 content (removes the metadata at the beginning) and also ensures padding is done correctly
  let encoded = result.replace(/^data:(.*,)?/, "");
  if (encoded.length % 4 > 0) {
    encoded += "=".repeat(4 - (encoded.length % 4));
  }
  return encoded;
};

export const formatBytes = (bytes: number, decimals = 2): string => {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};

export const fileExtensionValid = (file: File, allowedExtensions = /(\.jpg|\.jpeg)$/i): boolean => {
  if (!allowedExtensions.exec(file.name)) {
    return false;
  } else {
    return true;
  }
};

export const fileImssExtensionValid = (file: File, allowedExtensions = /(\.jpg|\.jpeg|\.png|\.pdf)$/i): boolean => {
  if (!allowedExtensions.exec(file.name)) {
    return false;
  } else {
    return true;
  }
};

export const filePreExtensionValid = (file: File, allowedExtensions = /(\.jpg|\.jpeg|\.png|\.pdf)$/i): boolean => {
  if (!allowedExtensions.exec(file.name)) {
    return false;
  } else {
    return true;
  }
};

export const fileSizeValid = (file: File, maxSize = 4096): boolean => {
  const size = file.size / 1024;
  return size > 0 && size <= maxSize;
};

export const aesEncrypt = (value: string): string => {
  return btoa(aes.encrypt(value, enc.parse(KEY), { iv: enc.parse(IV) }).toString());
};

export const aesDecrypt = (value: string): string | undefined => {
  try {
    const ciphertext = atob(value);
    return enc.stringify(aes.decrypt(ciphertext, enc.parse(KEY), { iv: enc.parse(IV) })).toString();
  } catch (error) {
    logException(error);
    return undefined;
  }
};

export const isEmpty = (value: string | undefined): boolean => {
  return !value || value.length === 0;
};

export const md5Encrypt = (value: string): string => {
  return md5(value).toString();
};
